import { BehaviorSubject } from 'rxjs';

export interface MobileHeaderState {
  hideMainHeader: boolean;
}

/**
 * Mobile header state manager
 * Controls the visibility of the main dashboard header on mobile devices
 */
export class MobileHeaderStore {
  private static _state = new BehaviorSubject<MobileHeaderState>({
    hideMainHeader: false,
  });

  public static readonly state$ = MobileHeaderStore._state.asObservable();

  static get currentState(): MobileHeaderState {
    return MobileHeaderStore._state.value;
  }

  /**
   * Hide or show the main dashboard header on mobile
   * Used by detail pages that have their own custom mobile header
   */
  static setHideMainHeader(hide: boolean): void {
    const currentState = MobileHeaderStore._state.value;
    if (currentState.hideMainHeader !== hide) {
      MobileHeaderStore._state.next({
        ...currentState,
        hideMainHeader: hide,
      });
    }
  }
}
